import React, { useState } from 'react'

import InputBase from '@material-ui/core/InputBase'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'

import { fade, makeStyles } from '@material-ui/core/styles'

import { Toast } from '../../../utils'

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  // search: {
  //   position: 'relative',
  //   borderRadius: theme.shape.borderRadius,
  //   backgroundColor: fade(theme.palette.common.white, 0.15),
  //   '&:hover': {
  //     backgroundColor: fade(theme.palette.common.white, 0.25)
  //   },
  //   marginRight: theme.spacing(2),
  //   marginLeft: 0,
  //   width: '100%',
  //   [theme.breakpoints.up('sm')]: {
  //     marginLeft: theme.spacing(3),
  //     width: 'auto'
  //   }
  // },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#868787', 0.15),
    '&:hover': {
      backgroundColor: fade('#868787', 0.25)
    },
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%'
  },
  searchIcon: {
    color: 'white'
  },
  clearIcon: {
    color: 'white'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
    height: '3rem'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    color: 'white',
    fontSize: '1.5rem'
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
}))

const SearchBar = ({ onSearch, name, id, setSearchOpen, searchRef, clearSearch }) => {
  const classes = useStyles()

  const [searchText, setSearchText] = useState('')
  // const [searchBarIsActive, setSearchBarIsActive] = useState(false)

  const handleChange = (e) => {
    e.persist()
    const text = e.target.value
    setSearchText(text)
  }

  const handleSearch = () => {
    if (searchText.length >= 3) {
      onSearch(searchText, setSearchText)
      setSearchText('')
      setSearchOpen(false)
    } else {
      // console.error('Too few characters in text field')
      Toast.fire({
        icon: 'info',
        // title: 'Too few characters in the search field.'
        title: 'Please type three or more characters in the search field.'
      })
    }
  }

  return (
    <>
      <div className={classes.search}>
        <InputBase
          id={id}
          name={name}
          inputRef={searchRef}
          // inputProps={{ autoFocus: true }}
          onChange={handleChange}
          placeholder='Search…'
          value={searchText}
          onKeyDown={(e) => { if (e.key === 'Enter') { handleSearch() } }}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput
          }}
          startAdornment={
            <InputAdornment position='start'>
              <IconButton onClick={() => handleSearch()}>
                <SearchIcon className={classes.searchIcon} />
              </IconButton>
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment>
              <IconButton onClick={(e) => { e.preventDefault(); setSearchText(''); setSearchOpen(false) }}>
                <ClearIcon className={classes.clearIcon} />
              </IconButton>
            </InputAdornment>
          }
        />
        {/* {renderClearButton()} */}
      </div>
    </>
  )
}

export default SearchBar
